import analytics from '@viewlift/analytics/analytics-core/index.cjs'
import googleAnalytics from '@viewlift/analytics/google-analytics/index.cjs'
import userBeacon from '@viewlift/analytics/user-beacon/index.cjs';
import fbPixel from '@viewlift/analytics/facebook/index.cjs';
import {convivaECO,convivaVideoSensor} from '@viewlift/analytics/conviva/index.cjs';
import { parseJSON } from "../OnBoarding-V2/utils/parseJSON"
import {getDeviceId, getToken} from "../helpers"
import Cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import { getStorageItem } from './storageManager';
import { pixel_Events } from './analyticsMap';
import { isUserSubscribed } from './checkSubscription';
declare const window: any;
export default async function trackEvent(eventName, payload,gaId) {
  let commonPayload={
    platform:'Web',
    etstamp : Date. now(),
    // device_id : getDeviceId() || "", //This violates GDPR/Google terms
  }
  const getCookie:any = Cookies.get("cc_cookie")
  const getparsedCookie = getCookie && JSON.parse(getCookie)
  const oneTrustCookie = window?.fireGaEvents
  if (getparsedCookie?.level?.includes("performanceCookie") || oneTrustCookie){
    // Targeting Cookies(optional) category will control GTM, FB and Clevertap loading
    // Performance Cookies category will control GA loading.
    // if(getparsedCookie?.level?.includes("performanceCookie")){
      if (typeof window !== 'undefined' && window?.app_data) { 
        let trackingID = gaId || window?.app_data?.appcmsPlatform?.analytics?.googleAnalyticsId
        if(window?.dataLayer) {
          window.dataLayer.push({
            'event': eventName,
            ...payload
          })
        }
        if(trackingID){
          const userData:any = getStorageItem("AuthenticationStore")

          const userSubscriptionPlanId = (userData?.user?.monetizationPlan?.id) || ''
          const userSubscriptionPlanName = (userData?.user?.monetizationPlan?.name) || ''
          const currentSelectedPlanObj:any = sessionStorage.getItem('currentPlan') ? parseJSON(sessionStorage.getItem('currentPlan')) : ''
          let currentSelectedPlanId = ''
          let currentSelectedPlanName = ''

          if(currentSelectedPlanObj){
            currentSelectedPlanId = currentSelectedPlanObj?.id
            currentSelectedPlanName = currentSelectedPlanObj?.name
          }

          const userProperties = {
            device_platform: 'Web', 
            logged_in_status: userData?.user?.userId ? 'Yes' : 'No',
            subscribed_status: isUserSubscribed() ? 'Yes' : 'No',
            device_id: getDeviceId() || '',
            subscription_plan: userSubscriptionPlanName || currentSelectedPlanName || '',
            plan_id: userSubscriptionPlanId || currentSelectedPlanId || '', 
            user_city: userData?.user?.city || ''
          }
          analytics({
            app: 'analytics',
            eventName: eventName,
            plugins: [
             googleAnalytics({
               trackingId: trackingID,
               initialize: () => {
               },
               payload: {...payload,...commonPayload},
               userProperties: userProperties ? userProperties : null
             }),
           ]
          })
        }
      }
    // }
  }
}

export async function trackUserEvent(payload) {
  let token=await getToken();
  if (typeof window !== 'undefined') { 
    return analytics({
      app: 'user-analytics',
      apiBaseUrl: window?.app_data?.appcmsMain?.apiConfig?.userBeaconUrl,
      token:token,
      plugins: [
       userBeacon({
         initialize: () => {
         },
         payload: payload
       }),
     ]
    })
  }
}
export function trackFbEvent(eventName, payload, eventID?: string) {
  if (typeof window === 'undefined') {
    return;
  }

  const conversionApi = window?.app_data?.appcmsMain?.analytics?.conversionApi;
  const finalPayload = eventID ? { ...payload, event_id: eventID } : payload;

  return getToken()
    .then((token) => {
      try {
        return analytics({
          app: 'fb-analytics',
          eventName: eventName,
          trackingBaseUrl:
            window?.app_data?.appcmsMain?.apiConfig?.trackingBaseUrl || window?.app_data?.appcmsMain?.trackingBaseUrl,
          apiBaseUrl: window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl,
          eventType: 'fbConversionAPI',
          platformDetails: {
            site: window?.app_data?.appcmsMain?.internalName,
            conversionApiEnabled: conversionApi?.conversionApi,
            pixelId: conversionApi?.pixelID,
            device: 'web',
            token: token,
          },
          plugins: [
            fbPixel({
              initialize: () => {},
              payload: finalPayload,
            }),
          ],
        })
      } catch (error) {
        console.error('trackFbEvent failed', error)
      }
    })
    .catch((error) => {
      console.error('trackFbEvent failed', error)
    })
}
export function trackPixelEvent(eventName, payload, eventID?: string) {
  if (typeof window === 'undefined') {
    return;
  }

  const conversionApi = window?.app_data?.appcmsMain?.analytics?.conversionApi;

  try {
    return analytics({
      app: 'fb-analytics',
      eventName: eventName,
      trackingBaseUrl:
        window?.app_data?.appcmsMain?.apiConfig?.trackingBaseUrl || window?.app_data?.appcmsMain?.trackingBaseUrl,
      apiBaseUrl: window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl,
      eventType: 'fbPixel',
      eventID: eventID,
      platformDetails: {
        site: window?.app_data?.appcmsMain?.internalName,
        conversionApiEnabled: conversionApi?.conversionApi,
        pixelId: conversionApi?.pixelID,
      },
      plugins: [
        fbPixel({
          initialize: () => {},
          payload: payload,
        }),
      ],
    })?.catch?.((error: unknown) => {
      console.error('trackPixelEvent failed', error)
    })
  } catch (error) {
    console.error('trackPixelEvent failed', error)
  }
}

export const getUserProperties = async () => {
  const userData:any = getStorageItem("AuthenticationStore")
    const userProperties = {
      device_platform: 'Web', 
      logged_in_status: userData?.user?.userId ? 'Yes' : 'No',
      subscribed_status: isUserSubscribed() ? 'Yes' : 'No',
      // device_id: getDeviceId() || '', //This violates GDPR/Google terms
    }
    return userProperties
} 

export const trackBrazeEvents = (eventName,payload) => {
  let brazeObject = window?.app_data?.appcmsPlatform?.notifications?.braze
  if(brazeObject && brazeObject?.apiKey && brazeObject?.baseUrl){
    import(
      /* webpackExports: ["logCustomEvent"] */
      "@braze/web-sdk"
    ).then(({logCustomEvent}) => {
      logCustomEvent(eventName,payload)
    })
  }
}
export const trackRKPEvent = (ename: string) => {
  window.rkp('event', ename);
}


export function trackConvivaEco(eventName, payload) {
  if (typeof window !== 'undefined') {
    const {customerKey,appName,enabled} = window?.app_data?.appcmsPlatform?.analytics?.convivaConfig || {}

    if (!customerKey || !enabled) {
        return;
    }

    getToken().then(async (token) => {
    const userDetail:any = jwtDecode(token);
    const userData = (getStorageItem("AuthenticationStore")) as { user?: { userId?: string } } || {};
    const userId = userData?.user?.userId || (userDetail?.userId ?? '');

    return analytics({
      app: 'conviva-eco',
      eventName: eventName,
      eventType: eventName,
      plugins: [
        convivaECO({
          initialize: () => {
          },
          initConfig: {appName: appName || "WEB",customerKey,userId},
          payload: payload,
        }),
      ]
    })
    })
  }
}

export  function trackConvivaVideoSensor(eventName, payload) {
 if (typeof window !== 'undefined') { 
  const {customerKey,enabled} = window?.app_data?.appcmsPlatform?.analytics?.convivaConfig || {}

  if (!customerKey || !enabled) return

  return analytics({
   app: 'conviva-video',
   eventName: eventName,
   eventType: eventName,
   plugins: [
     convivaVideoSensor({
      initialize: () => {
       return true
      },
      initConfig: {customerKey:customerKey,debug:false},
      payload: payload,
    }),
  ]
 })
 }
}

export function getConvivaVideoSensorConfig (user:any) {
  if (typeof window !== 'undefined') { 
    
    const {enabled,appName,customerKey} = window?.app_data?.appcmsPlatform?.analytics?.convivaConfig || {};
    const subscriptionData = user?.userInfo?.subscription || user?.subscription || {};
    const paymentHandler =  subscriptionData?.subscriptionInfo?.paymentHandler || null;
    const tveProvider = user?.tveMetadata?.idpName || null;
    const isUserVip = user?.isVip || false;
    const paymentHandlerType = isUserVip ? "FREE" : tveProvider ? "TVE" : paymentHandler

    return {
      trackConvivaPlayerEvent: trackConvivaVideoSensor,
      appName: appName || "WEB",
      enable: customerKey && enabled,
      customerKey,
      paymentHandler: paymentHandlerType,
      tveProvider,
     ...(process.env.NODE_ENV != 'production' && { gatewayUrl: `https://${customerKey}.ts-testonly.conviva.com`,})
    }
  }
}

export function getPixelConversionEvent(renewalCycleType :string) {
  const type = String(renewalCycleType || "").toUpperCase();
  if (type === "MONTH") return pixel_Events.MONTHLY_SIGN_UP;
  if (type === "YEAR") return pixel_Events?.ANNUAL_SIGN_UP;
  return null;
};